<template>
	<div class="message-watcher">
		<div v-if="isLoading" class="lds-grid">
			<div class="lds-ripple"><div></div><div></div></div>
			<p>Loading notifications...</p>
		</div>
		<div class="notifications" v-if="!isLoading && notifications.length">
			<div class="portal-notification" v-for="(notification, index) in notifications" :key="index">
				 <a :href="'/dashboard/patients/'+notification.sender_id">{{ notification.sender_name }}</a> - 
				 <span class="message-watcher-notification-date">{{ localTime(notification.dateCreated.date) }}</span>
			</div>

			<div class="message-watcher-next">
				<div class="pagination gap-2">
					<span v-if="page > 0" @click="prevPage" class="click-effect">
						<i class="fas fa-chevron-left"></i>Prev
					</span>
					<span v-if="notifications.length >= 10" @click="nextPage" class="click-effect">
						Next<i class="fas fa-chevron-right"></i>
					</span>
				</div>
			</div>
			<div class="pagination-info">
				<div class="pagination-info-item">
					<p>Current Page: {{ page + 1 }}</p>
				</div>
				<div class="pagination-info-item-2">
					<p>Pages: {{ totalPages }}</p>
					<p>Items: {{ totalItems }}</p>
				</div>
			</div>
		</div>
		<div v-else-if="!isLoading">
			There are no new messages.
		</div>
	</div>
</template>

<style scoped>
	.pagination-info-item-2 p {
		margin: 0;
	}
	.pagination-info-item-2 {
		display: flex;
		justify-content: space-around;
	}
	.message-watcher-next {
		padding: 20px;
		display: flex;
		justify-content: center;
	}
	.message-watcher-notification-date {
		color: #949494;
		font-size: 12px;
	}
	.gap-2 {
		gap: 50px;
	}
	.lds-grid {
		display: flex;
		align-items: center;
		margin-bottom: 30px;
		justify-content: center;
	}
	.lds-ripple,
	.lds-ripple div {
		box-sizing: border-box;
	}
	.lds-ripple {
		display: inline-block;
		position: relative;
		width: 80px;
		height: 80px;
	}
	.lds-ripple div {
		position: absolute;
		border: 4px solid #243153;
		opacity: 1;
		border-radius: 50%;
		animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
	}
	.lds-ripple div:nth-child(2) {
		animation-delay: -0.5s;
	}
	@keyframes lds-ripple {
		0% {
			top: 36px;
			left: 36px;
			width: 8px;
			height: 8px;
			opacity: 0;
		}
		4.9% {
			top: 36px;
			left: 36px;
			width: 8px;
			height: 8px;
			opacity: 0;
		}
		5% {
			top: 36px;
			left: 36px;
			width: 8px;
			height: 8px;
			opacity: 1;
		}
		100% {
			top: 0;
			left: 0;
			width: 80px;
			height: 80px;
			opacity: 0;
		}
	}
	.lds-grid p {
		color: #243153;
	}
	.pagination-info {
		text-align: center;
		margin-top: 10px;
	}
	.click-effect {
		cursor: pointer;
		transition: transform 0.1s ease-in-out;
	}
	.click-effect:active {
		transform: scale(0.95);
	}
</style>

<script>
	import axios from 'axios';
	import moment from 'moment';
	import { EventBus } from './event-bus';

	export default {
		props: ['inputName', 'prepopulate'],
		data: function () {
			return {
				notifications: [],
				pollingInterval: 100000, // in milliseconds,
				newMessages: [],
				page: 0,
				isLoading: false,
				totalPages: 0,
				totalItems: 0,
				selectedCategory: ''
			}
		},
		mounted() {
			// Listen for product category selection events
			EventBus.$on('product-category-selected', category => {
				this.selectedCategory = category;
				this.page = 0; // Reset to first page
				this.lookForNewMessages();
			});
			
			this.lookForNewMessages();
		},
		methods: {
			loadProductCategories() {
				axios.get('/api/v1/product-categories')
					.then(response => {
						this.productCategories = response.data.data;
					})
					.catch(error => {
						console.error('Error loading product categories:', error);
					});
			},
			nextPage: function() {
				this.page++;
				this.lookForNewMessages();
			},
			prevPage: function() {
				this.page--;
				this.lookForNewMessages();
			},
			lookForNewMessages: function() {
				this.isLoading = true;
				
				// Build the URL with query parameters
				let url = `/api/v1/messages/new?page=${this.page}`;
				
				// Add category filter if selected
				if (this.selectedCategory) {
					url += `&category=${this.selectedCategory}`;
				}
				
				axios.get(url)
					.then((response) => {
						if (response.data.data) {
							this.newMessages = response.data.data.data;
							this.processNewMessages();
							this.totalPages = response.data.pagination.totalPages;
							this.totalItems = response.data.pagination.totalItems;
						} else {
							this.newMessages = [];
						}
					})
					.finally(() => {
						this.isLoading = false;
					})
					.catch(function (error) {
						console.error('Error fetching messages:', error);
					});
			},

			processNewMessages: function() {
				let newNotifications = [];
				this.newMessages.forEach((message) => {
					if (newNotifications.filter((notification) => { return notification.sender_id == message.sender.id}).length == 0) {
						newNotifications.push({ sender_id: message.sender.id,  sender_name: (message.sender.firstName + ' ' + message.sender.lastName), dateCreated: message.dateCreated });
					}
				});
				this.notifications = newNotifications;
			},
			localTime(datetime) {
				datetime = datetime.replace(/\.000000/, '');
				let utcDate = moment.utc(datetime);
				return moment(utcDate)
				.local()
				.calendar('', { sameElse: 'M/D/YYYY, h:mm A' });
			},
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/MessageWatcher.vue